"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfServiceAppointments = void 0;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var self_service_helper_1 = require("./self-service.helper");
var self_service_references_1 = require("./self-service-references");
var self_service_service_1 = require("./self-service.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var SelfServiceAppointments = /** @class */ (function () {
    function SelfServiceAppointments() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    }
    SelfServiceAppointments.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selfServiceData, selfServiceIndividual, appointments;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (0, generator_const_1._HideErrorMessage)();
                        (0, generator_const_1._CreateLoadingScreen)();
                        selfServiceData = (0, self_service_helper_1.loadSelfServiceToken)();
                        if (!selfServiceData)
                            return [2 /*return*/];
                        this.ssid = selfServiceData.ssid;
                        return [4 /*yield*/, self_service_service_1.SelfServiceService.getSelfServiceIndividual(selfServiceData.ssid, this.config)];
                    case 1:
                        selfServiceIndividual = _b.sent();
                        if (!!('errorMessage' in selfServiceIndividual)) return [3 /*break*/, 3];
                        this.individualId = (_a = selfServiceIndividual.individual) === null || _a === void 0 ? void 0 : _a.id;
                        return [4 /*yield*/, (0, self_service_helper_1.replaceIndividualPlaceholders)(this.$container, selfServiceIndividual)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [4 /*yield*/, self_service_service_1.SelfServiceService.getUpcomingAppointments(selfServiceData.ssid, this.config)];
                    case 4:
                        appointments = _b.sent();
                        (0, generator_const_1._DeleteLoadingScreen)();
                        if ('errorMessage' in appointments) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(appointments.errorMessage));
                            return [2 /*return*/];
                        }
                        this.renderAppointments(appointments);
                        return [2 /*return*/];
                }
            });
        });
    };
    SelfServiceAppointments.prototype.renderAppointments = function (appointments) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var appointmentReference = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.appointment;
        if (!((_b = appointmentReference === null || appointmentReference === void 0 ? void 0 : appointmentReference.parent) === null || _b === void 0 ? void 0 : _b.length)) {
            console.error('Self-service appointments module needs a data-ref="appointment" template.');
            return;
        }
        (_c = appointmentReference.removeClones) === null || _c === void 0 ? void 0 : _c.call(appointmentReference);
        (_f = (_e = (_d = this.module.references) === null || _d === void 0 ? void 0 : _d.appointmentConfirmed) === null || _e === void 0 ? void 0 : _e.removeClones) === null || _f === void 0 ? void 0 : _f.call(_e);
        (_j = (_h = (_g = this.module.references) === null || _g === void 0 ? void 0 : _g.appointmentCanceled) === null || _h === void 0 ? void 0 : _h.removeClones) === null || _j === void 0 ? void 0 : _j.call(_h);
        this.$container.find('.fittec-self-service-appointments-empty').remove();
        if (!appointments.length) {
            var emptyState = document.createElement('p');
            emptyState.className = 'fittec-self-service-appointments-empty';
            emptyState.textContent = translation_1.default.t('You have no upcoming appointments');
            appointmentReference.parent.append(emptyState);
            return;
        }
        for (var _i = 0, appointments_1 = appointments; _i < appointments_1.length; _i++) {
            var appointment = appointments_1[_i];
            var attendanceStatus = getAttendanceStatus(appointment, this.individualId);
            var canceledTemplate = (_k = this.module.references) === null || _k === void 0 ? void 0 : _k.appointmentCanceled;
            var appointmentTemplate = attendanceStatus === 'cancelled' && ((_l = canceledTemplate === null || canceledTemplate === void 0 ? void 0 : canceledTemplate.domElement) === null || _l === void 0 ? void 0 : _l.length) ? canceledTemplate : appointmentReference;
            var appointmentClone = (_m = appointmentTemplate.cloneDomElement) === null || _m === void 0 ? void 0 : _m.call(appointmentTemplate);
            if (!(appointmentClone === null || appointmentClone === void 0 ? void 0 : appointmentClone.length))
                continue;
            this.replaceAppointmentPlaceholders(appointmentClone, appointment);
            this.registerAttendanceActions(appointmentClone, appointment);
            this.setSelectedAttendanceButton(appointmentClone, attendanceStatus);
            appointmentReference.parent.append(appointmentClone);
        }
    };
    SelfServiceAppointments.prototype.replaceAppointmentPlaceholders = function (appointmentClone, appointment) {
        var cloneElement = appointmentClone.get(0);
        if (!cloneElement)
            return;
        var placeholders = Array.from(cloneElement.querySelectorAll('[data-get]'));
        if (cloneElement.hasAttribute('data-get')) {
            placeholders.push(cloneElement);
        }
        for (var _i = 0, placeholders_1 = placeholders; _i < placeholders_1.length; _i++) {
            var placeholder = placeholders_1[_i];
            var value = getAppointmentPlaceholderValue(appointment, placeholder.getAttribute('data-get'));
            if (value !== undefined) {
                placeholder.textContent = value;
                placeholder.setAttribute('data-i18n-ignore', 'true');
                placeholder.setAttribute('translate', 'no');
            }
        }
    };
    SelfServiceAppointments.prototype.registerAttendanceActions = function (appointmentClone, appointment) {
        var _this = this;
        if (!this.ssid)
            return;
        var ssid = this.ssid;
        appointmentClone
            .find("[data-action=\"".concat(self_service_references_1._SelfServiceAppointmentsReferences.confirmAttendance.uid, "\"]"))
            .on('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runAttendanceAction(event.currentTarget, function () { return self_service_service_1.SelfServiceService.setAppointmentAttendance(ssid, appointment.id, 'confirmed', _this.config); }, function () { return _this.replaceAppointmentWithStatus(appointmentClone, appointment, 'confirmed'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        appointmentClone
            .find("[data-action=\"".concat(self_service_references_1._SelfServiceAppointmentsReferences.cancelAttendance.uid, "\"]"))
            .on('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runAttendanceAction(event.currentTarget, function () { return self_service_service_1.SelfServiceService.setAppointmentAttendance(ssid, appointment.id, 'cancelled', _this.config); }, function () { return _this.replaceAppointmentWithStatus(appointmentClone, appointment, 'cancelled'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    SelfServiceAppointments.prototype.setSelectedAttendanceButton = function (appointmentClone, attendanceStatus) {
        this.setStatusSelectedClass(appointmentClone.find("[data-action=\"".concat(self_service_references_1._SelfServiceAppointmentsReferences.confirmAttendance.uid, "\"]")), attendanceStatus === 'confirmed');
        this.setStatusSelectedClass(appointmentClone.find("[data-action=\"".concat(self_service_references_1._SelfServiceAppointmentsReferences.cancelAttendance.uid, "\"]")), attendanceStatus === 'cancelled');
    };
    SelfServiceAppointments.prototype.replaceAppointmentWithStatus = function (appointmentClone, appointment, attendanceStatus) {
        var _a, _b, _c;
        var referenceKey = attendanceStatus === 'confirmed' ? 'appointmentConfirmed' : 'appointmentCanceled';
        var statusClone = (_c = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a[referenceKey]) === null || _b === void 0 ? void 0 : _b.cloneDomElement) === null || _c === void 0 ? void 0 : _c.call(_b);
        if (!(statusClone === null || statusClone === void 0 ? void 0 : statusClone.length)) {
            this.setSelectedAttendanceButton(appointmentClone, attendanceStatus);
            return;
        }
        this.replaceAppointmentPlaceholders(statusClone, appointment);
        appointmentClone.replaceWith(statusClone);
    };
    SelfServiceAppointments.prototype.setStatusSelectedClass = function (button, isSelected) {
        if (isSelected) {
            button.addClass('status-selected');
        }
        else {
            button.removeClass('status-selected');
        }
    };
    SelfServiceAppointments.prototype.runAttendanceAction = function (button, action, onSuccess) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        button.disabled = true;
                        (0, generator_const_1._CreateLoadingScreen)();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, action()];
                    case 2:
                        result = _a.sent();
                        if ('errorMessage' in result) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(result.errorMessage));
                        }
                        else {
                            onSuccess();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        (0, generator_const_1._DeleteLoadingScreen)();
                        button.disabled = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return SelfServiceAppointments;
}());
exports.SelfServiceAppointments = SelfServiceAppointments;
function getAppointmentPlaceholderValue(appointment, key) {
    var _a;
    switch (key) {
        case self_service_references_1._SelfServiceAppointmentsReferences.appointmentStartTime.uid:
            return formatAppointmentTime(appointment.startAt);
        case self_service_references_1._SelfServiceAppointmentsReferences.appointmentEndTime.uid:
            return formatAppointmentTime(appointment.endAt);
        case self_service_references_1._SelfServiceAppointmentsReferences.appointmentDuration.uid:
            return formatAppointmentDuration(appointment.startAt, appointment.endAt);
        case self_service_references_1._SelfServiceAppointmentsReferences.appointmentTitle.uid:
            return (_a = appointment.title) !== null && _a !== void 0 ? _a : translation_1.default.t('No title');
        default:
            return undefined;
    }
}
function formatAppointmentTime(timestamp) {
    var date = new Date(timestamp);
    if (Number.isNaN(date.getTime()))
        return '';
    var formattedDate = date.toLocaleDateString('de-DE', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
    });
    var formattedTime = date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    return "".concat(formattedDate, " ").concat(formattedTime, " ").concat(translation_1.default.t('Uhr'));
}
function formatAppointmentDuration(startAt, endAt) {
    var durationInMinutes = Math.round((endAt - startAt) / (1000 * 60));
    if (!Number.isFinite(durationInMinutes) || durationInMinutes < 0)
        return '';
    var isWholeHour = durationInMinutes > 0 && durationInMinutes % 60 === 0;
    var unit = isWholeHour ? 'hour' : 'minute';
    var value = isWholeHour ? durationInMinutes / 60 : durationInMinutes;
    return new Intl.NumberFormat(translation_1.default.language, { style: 'unit', unit: unit, unitDisplay: 'long' }).format(value);
}
function getAttendanceStatus(appointment, individualId) {
    var _a, _b;
    if (appointment.participantStatus) {
        return appointment.participantStatus;
    }
    if (!individualId)
        return;
    return (_b = (_a = appointment.members) === null || _a === void 0 ? void 0 : _a.find(function (member) { return member.individualId === individualId; })) === null || _b === void 0 ? void 0 : _b.attendanceStatus;
}
